import { Tabs, TabsProps } from "antd";
import { t } from "i18next";
import { useContext, useEffect, useState } from "react";
import { PeriodicReportsContext } from "../../../../../modules/obligee/periodicReports/periodicReports.context";
import { TobaccoReportType } from "../../../../../modules/obligee/periodicReports/periodicReports.types";
import { TobaccoTable } from "./TobaccoTable";

interface TobaccoReportProps {
  setType: (type: TobaccoReportType) => void;
}
const TobaccoReport = ({ setType }: TobaccoReportProps) => {
  const { periodicReports } = useContext(PeriodicReportsContext);

  const defaultSubtab = () => {
    return periodicReports.hasTobaccoCategory?.hasCigarete
      ? TobaccoReportType.CIGARETE
      : TobaccoReportType.NESAGOREVAJUCI;
  };

  const [selectedTab, setSelectedTab] = useState<string>(defaultSubtab());

  const tabs: TabsProps["items"] = [
    ...(periodicReports?.hasTobaccoCategory?.hasCigarete
      ? [
          {
            key: TobaccoReportType.CIGARETE,
            label: t("AKCIZNE_MARKICE.CIGARETE"),
            children: <TobaccoTable type={TobaccoReportType.CIGARETE} />,
          },
        ]
      : []),
    ...(periodicReports?.hasTobaccoCategory?.hasNesagorevajuci
      ? [
          {
            key: TobaccoReportType.NESAGOREVAJUCI,
            label: t("AKCIZNE_MARKICE.NESAGOREVAJUCI_DUVAN"),
            children: <TobaccoTable type={TobaccoReportType.NESAGOREVAJUCI} />,
          },
        ]
      : []),
  ];

  const setTabHandler = (tabKey: string) => {
    setSelectedTab(tabKey);
  };

  useEffect(() => {
    setType(selectedTab as TobaccoReportType);
  }, [selectedTab]);

  return (
    <Tabs
      items={tabs}
      activeKey={selectedTab}
      onChange={setTabHandler}
      destroyInactiveTabPane
    />
  );
};

export default TobaccoReport;
